import { render, staticRenderFns } from "./aiGuideBook.vue?vue&type=template&id=4d85586e&scoped=true&"
import script from "./aiGuideBook.vue?vue&type=script&lang=js&"
export * from "./aiGuideBook.vue?vue&type=script&lang=js&"
import style0 from "./aiGuideBook.vue?vue&type=style&index=0&id=4d85586e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d85586e",
  null
  
)

export default component.exports